import Vue from 'vue'
import App from '@/App'
import VueUtear from 'vue-utear'
import Router from 'vue-router'
import router from './router'
import VueMeta from 'vue-meta'
import 'vue-utear/dist/vue-utear.css'
import '@/assets/css/index.less'
import store from '@/models'
import http from '@/assets/js/http'
import '@/components'
import ace from 'ace-builds'
import { InputNumber, Button } from 'element-ui'
// import verifyFn from '@/assets/js/routePermission'

Vue.config.productionTip = false
Vue.use(VueUtear)
Vue.use(VueMeta)
Vue.use(Router)
Vue.use(ace)

Vue.use(InputNumber)
Vue.use(Button)

Vue.prototype.$http = http
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

router.beforeEach((to, form, next) => {
  const { allPermiList } = store.getters
  // if (verifyFn(to.path, allPermiList)) {
  // eslint-disable-next-line no-undef
  const sysKey = BUILD_ENV === 'ali' ? 'argus-ali-admin' : 'argus-admin'
  if (allPermiList.includes(sysKey) || ['/401', '/welcome'].includes(to.path)) {
    next()
  } else {
    next('/401')
  }
})

// store.dispatch({
//   type: 'fetchNavList'
// })
// store.dispatch({
//   type: 'showUser'
// })
